import React from 'react';
import { TASKS } from '_constants';
import { fetchAgentTasks, fetchSingleTaskById, updateTask, updateTaskUsingPatch } from '../services/tasks.services';
import { isResponseSuccess } from 'helpers';
import { showServerResponse } from './modals.actions';
import moment from 'moment';
import _ from 'lodash';
import { APPOINTMENT_STATUS, APPOINTMENTS } from '../constants';
import { fetchMemberAppointments } from '../services/appointments.services';

const updateCountIconTasks = () => (dispatch, getState) => {
  const currState = getState();
  const { tasks = [] } = currState.tasks;
  dispatch({ type: TASKS.UPDATE_BADGE_COUNT, displayCount: true, totalItemsCount: tasks.length });
};

const fetchTasks = () => async (dispatch, getState) => {
  const memberKey = getState().userprofile.memberKey;
  const response = await dispatch(fetchAgentTasks(memberKey));
  if (isResponseSuccess(response)) {
    const tasks = response.data;
    const startDate = moment().subtract(APPOINTMENTS.MONTHS_LIMIT, 'months').startOf('month').format('MM/DD/YYYY');
    const endDate = moment().add(APPOINTMENTS.MONTHS_LIMIT, 'months').endOf('month').format('MM/DD/YYYY');
    const apptRes = await dispatch(fetchMemberAppointments(memberKey, startDate, endDate));
    if (isResponseSuccess(apptRes)) {
      const appts = apptRes.data || [];
      const activeAppts = appts.filter(appt => _.get(appt, 'eventStatus.id', null) !== APPOINTMENT_STATUS.TENTATIVE.id);
      const activeOppIds = activeAppts.map(appt => _.get(appt, 'opportunityKeys', []));
      const distinctOppIds = new Set(_.flattenDeep(activeOppIds));
      const nonCompletedActiveTasks = tasks.filter(task => task.isCompleted === false && task.active && distinctOppIds.has(task.opportunityId));
      dispatch({ type: TASKS.FETCH_TASKS, value: nonCompletedActiveTasks });
      dispatch(updateCountIconTasks());
    }
    return response;
  }
};

const fetchTaskById = (taskId) => async (dispatch) => {
  dispatch({ type: TASKS.START_FETCH_TASK });
  const response = await dispatch(fetchSingleTaskById(taskId));
  if (isResponseSuccess(response)) {
    dispatch({ type: TASKS.SET_ACTIVE_TASK, payload: response.data });
    return response.data;
  }
  dispatch({ type: TASKS.END_FETCH_TASK });
};

const putUpdateTask = (taskId, taskObj, successResponseText, errorResponseText, routeTo) => async (dispatch, getState) => {
  const response = await dispatch(updateTask(taskId, taskObj));
  dispatch(showServerResponse(response, successResponseText, errorResponseText, routeTo));
};

const patchUpdateTask = (taskId, taskObj, responseText, errorResponseText, routeTo) => async (dispatch, getState) => {
  const response = await dispatch(updateTaskUsingPatch(taskId, taskObj));
  dispatch(showServerResponse(response, responseText, errorResponseText, routeTo));
};

const buildTaskStatus = (task) => {
  if (moment() > moment(task.startTime)) {
    return (
      <div className='appt-status-label'>
        {'PAST DUE'}
      </div>
    );
  }
};

export const taskActions = {
  fetchTasks,
  fetchTaskById,
  putUpdateTask,
  patchUpdateTask,
  buildTaskStatus
};
